export const MINIMUM_DEEPLE_PAY_WITHDRAW_AMOUNT = 100;
export const MAXIMUM_DEEPLE_PAY_WITHDRAW_AMOUNT = 700000;
